<template>
  <Modal
    size="medium"
    primary-button-label="Save"
    tertiary-button-label="Cancel"
    :close-on-click-outside="false"
    active
    class="contact-details-modal"
    @onClose="onClose()"
    @onConfirm="onSubmitClick">
    <div slot="header">Update Contact Information</div>
    <div slot="content">
      <Form
        ref="contactDetailsForm"
        :form-data="formData"
        @onSubmitForm="onSubmit" />
    </div>
  </Modal>
</template>

<script>
import { contactDetailsModalInputFields } from "@/config/disputeUpdateModalConstant.js";

export default {
  name: "DisputeContactDetailsModal",
  props: {
    caseDetails: {
      type: Object,
      default: () => {},
    },
    disputeSelectedRows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: contactDetailsModalInputFields(this.caseDetails),
    };
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
    onSubmitClick() {
      this.$refs.contactDetailsForm.validate();
    },
    onSubmit(formState) {
      if (this.disputeSelectedRows.length) {
        this.$emit(
          "updateBulkContactDetails",
          this.disputeSelectedRows.map((item) => ({
            ...formState,
            ohpDisputeId: item.ohpDisputeId,
            updateRequestType: "CUSTOMER",
          }))
        );
      } else {
        this.$emit("updateContactDetails", {
          ...formState,
          updateRequestType: "CUSTOMER",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.contact-details-modal {
  .modal--medium {
    width: 400px;
    height: 468px;
  }
  &__block {
    margin-bottom: 24px;
  }
}
</style>
